module.exports = __webpack_public_path__ + "static/media/kuna.93df93d3.svg";